import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FiPrinter,
  FiClipboard,
  FiSearch,
  FiEdit,
  FiArrowLeft,
  FiArrowRight,
  FiX,
  FiCheck,
} from "react-icons/fi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import PageCreateHeader from "../../components/PageCreateHeader";

const CreateStockOpname = () => {
  const navigate = useNavigate();
  const [stockData, setStockData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [currentNoteIndex, setCurrentNoteIndex] = useState(null);
  const [noteInput, setNoteInput] = useState("");
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [descriptionInput, setDescriptionInput] = useState("");
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(
    localStorage.getItem("id_outlet") || "",
  );
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [totalPages, setTotalPages] = useState(1);
  const [pageData, setPageData] = useState([]); // data per halaman dari API

  const [itemObatSelected, setItemObatSelected] = useState({});
  const [batchObatSelected, setBatchObatSelected] = useState([]);
  const [itemAdjust, setItemAdjust] = useState([]);
  const [note, setNote] = useState({});
  const [notes, setNotes] = useState({});
  const [needDeleteBatch, setNeedDeleteBatch] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [kartuStockOpname, setKartuStockOpname] = useState([]);
  const [switchButton, setSwitchButton] = useState(false);

  const fetchObat = async (page = 1, search = "") => {
    try {
      const token = localStorage.getItem("token");
      const baseURL = `${process.env.REACT_APP_API_BASE_URL}/v1/drug`;

      const url = `${baseURL}?id_outlet=${selectedOutlet}&page=${page}&per_page=${itemsPerPage}&search=${search}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const drugs = response.data.data || [];

      // simpan data page yang sedang aktif
      setPageData(drugs);

      // merge agar inputan user tetap ada
      setStockData((prev) => {
        const updated = [...prev];
        const desiredFormat = "EEEE, dd-MM-yyyy HH:mm:ss";

        drugs.forEach((drug) => {
          const existingIndex = updated.findIndex((d) => d.id === drug.id);
          if (existingIndex === -1) {
            updated.push({
              id: drug.id,
              name: drug.name,
              stockInSystem: drug.stock,
              stockInWarehouse: "",
              selisih: 0,
              status: "Belum Dihitung",
              note: "",
              last_updated:
                (drug.last_update === "0001-01-01T00:00:00Z"
                  ? "N/A"
                  : format(new Date(drug.last_update), desiredFormat)) || "N/A",
            });
          } else {
            updated[existingIndex].stockInSystem = drug.stock;
          }
        });
        return updated;
      });
      setKartuStockOpname((prev) => {
        return [...prev, drugs];
      });

      setTotalPages(response.data.meta?.last_page || 1);
      setCurrentPage(response.data.meta?.current_page || page);
    } catch (error) {
      console.error("Gagal mengambil data obat:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedOutlet) {
      fetchObat(currentPage, searchTerm);
    }
  }, [selectedOutlet, currentPage, searchTerm]);

  useEffect(() => {
    const fetchOutlets = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const outletList = response.data.data || [];
        setOutlets(outletList);
      } catch (error) {
        console.error("Gagal mengambil data outlet:", error);
      }
    };

    if (role === "owner") {
      fetchOutlets();
    }
  }, [role]);

  const openDescModal = () => {
    if (itemAdjust.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Peringatan",
        text: "Tidak ada Obat yang di adjust",
      });
      return;
    }
    setShowDescriptionModal(true);
  };

  const openNotePopup = (index) => {
    setCurrentNoteIndex(index);
    // setNoteInput(filteredData[index].note || "");
    setShowNotePopup(true);
  };

  const saveNote = () => {
    const originalIndex = stockData.findIndex(
      (item) => item.id === filteredData[currentNoteIndex].id,
    );
    const updated = [...stockData];
    updated[originalIndex].note = noteInput;
    setStockData(updated);
    setShowNotePopup(false);
  };

  const handleSubmit = async () => {
    setLoadingSubmit(true);
    try {
      const token = localStorage.getItem("token");
      const outlet_id = parseInt(
        selectedOutlet || localStorage.getItem("id_outlet"),
      );
      const employee_id = parseInt(localStorage.getItem("employee_id"));

      const items = itemAdjust.map((item) => ({
        obat_id: item.obat_id,
        stock_system: parseInt(item.stock_system),
        batch: item.batch.map((b) => ({
          ...b,
          expired_at: b.expired_at?.split("T")[0],
        })),
        need_delete: item.need_delete,
        note: item.note,
      }));

      const payload = {
        outlet_id,
        employee_id,
        items,
        description: descriptionInput,
      };

      console.log("Payload yang dikirim ke API:", payload);

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v2/stock-opname`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setShowDescriptionModal(false);
      setDescriptionInput("");
      setShowSuccessPopup(true); // Tampilkan popup
      setTimeout(() => {
        setShowSuccessPopup(false);
        setLoadingSubmit(false);
        navigate("/inventory/stock-opname");
      }, 2000);
    } catch (err) {
      console.error("Gagal submit:", err);
      alert("Terjadi kesalahan saat proses Stock Opname.");
    }
  };

  const repairNotif = () => {
    Swal.fire({
      title: "Info",
      text: "Fitur ini masih dalam perbaikan.",
      icon: "info",
      confirmButtonText: "Mengerti",
      confirmButtonColor: "#3085d6",
      backdrop: true,
    });
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableRows = kartuStockOpname
      .map((item, index) => {
        return `
          <tr>
            <td style="border:1px solid #ccc; padding:8px;">${index + 1}</td>
            <td style="border:1px solid #ccc; padding:8px;">${item.name}</td>
            <td style="border:1px solid #ccc; padding:8px;">${item.stock}</td>
            <td style="border:1px solid #ccc; padding:8px;"></td>
          </tr>
        `;
      })
      .join("");

    const html = `
      <html>
        <head>
          <title>Kartu Stock Opname</title>
        </head>
        <body>
          <h2>Kartu Stock Opname</h2>
          <table style="border-collapse:collapse; width:100%;">
            <thead>
              <tr>
                <th style="border:1px solid #ccc; padding:8px;">No</th>
                <th style="border:1px solid #ccc; padding:8px;">Nama</th>
                <th style="border:1px solid #ccc; padding:8px;">Stock In System</th>
                <th style="border:1px solid #ccc; padding:8px;">Stock In Warehouse</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.print();
  };

  const currentItems = stockData;

  const openModalAturStock = (item) => {
    setItemObatSelected(item);

    const adjustedItem = itemAdjust.find((i) => i.obat_id === item.id);
    setBatchObatSelected(
      adjustedItem ? [...adjustedItem.batch] : [...item.batch],
    );
    setNote(notes[item.id] || adjustedItem?.note || "");
    document.getElementById("modal-so-obat-stock").classList.remove("hidden");
  };

  const closeModal = () => {
    if (needDeleteBatch.length > 0) {
      setNeedDeleteBatch([]);
    }
    document.getElementById("modal-so-obat-stock").classList.add("hidden");
  };

  const handleBatchChange = (index, field, value) => {
    setBatchObatSelected((prev) => {
      const updated = [...prev];
      let newValue = value;

      // Kalau sebelumnya 0 dan user ngetik angka baru, replace langsung
      if (field === "stock") {
        if (prev[index][field] === 0 && value !== "") {
          newValue = value.replace(/^0+/, ""); // hapus 0 di depan
        }
        // pastikan tetap hanya angka
        if (!/^\d*$/.test(newValue)) {
          return prev; // ignore kalau bukan angka
        }
        newValue = newValue === "" ? 0 : parseInt(newValue);
      }
      updated[index] = { ...updated[index], [field]: newValue };
      return updated;
    });
  };

  const handleAddToNeedDelete = (batch) => {
    const batchFilter = batchObatSelected.filter(
      (b) =>
        !itemAdjust
          .find((i) => i.obat_id === itemObatSelected.id)
          ?.need_delete?.includes(b.id),
    );
    if (batchFilter.length === 1) {
      Swal.fire({
        icon: "warning",
        title: "Peringatan",
        text: "Minimal harus ada 1 batch.",
      });
      return;
    }
    Swal.fire({
      title: `Are you sure delete this batch Exd: <b>${batch.expired_at?.split("T")[0]}</b> Stock: <b>${batch.stock}</b>?`,
      text: "You won't be able to revert this batch!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setBatchObatSelected((prev) => prev.filter((b) => b.id !== batch.id));
        setNeedDeleteBatch((prev) => [...prev, batch.id]);
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };

  const isBatchChanged = (oldBatch, newBatch) => {
    const oldMap = Object.fromEntries(
      oldBatch.map((b) => [
        b.id,
        { stock: Number(b.stock), expired_at: b.expired_at },
      ]),
    );

    const newMap = Object.fromEntries(
      newBatch.map((b) => [
        b.id,
        { stock: Number(b.stock), expired_at: b.expired_at },
      ]),
    );

    // 1. cek ada batch lama yang hilang atau berubah
    for (const id in oldMap) {
      if (!newMap[id]) return true;
      if (
        oldMap[id].stock !== newMap[id].stock ||
        oldMap[id].expired_at !== newMap[id].expired_at
      ) {
        return true;
      }
    }

    // 2. cek ada batch baru di new
    for (const id in newMap) {
      if (!oldMap[id]) return true;
    }
    return false;
  };

  const handleAdjustItem = (item, note, batchChange) => {
    // set batchChange.expired_at ke format YYYY-MM-DD
    // const oldBatch = itemObatSelected.batch || [];

    const hasChanged = isBatchChanged(item.batch, batchChange);
    // batchChange = batchChange.map((b) => ({
    //   ...b,
    //   expired_at: b.expired_at?.split("T")[0],
    // }));

    // if (!hasChanged && needDeleteBatch.length === 0) {
    //   // kalau tidak ada perubahan, jangan simpan
    //   setSwitchButton(false);
    //   closeModal();
    //   return;
    // }

    setItemAdjust((prev) => {
      // set unique by obat_id
      const existingIndex = prev.findIndex((itm) => itm.obat_id === item.id);
      if (!hasChanged && needDeleteBatch.length === 0) {
        if (existingIndex !== -1) {
          setSwitchButton(true);
          const updated = [...prev];
          updated.splice(existingIndex, 1);
          return updated;
        }
        return prev;
      }

      setSwitchButton(false);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          obat_id: item.id,
          stock_system: item.stock,
          note: note,
          batch: batchChange,
          need_delete:
            updated[existingIndex].need_delete.concat(needDeleteBatch),
        };
        return updated;
      }

      return [
        ...prev,
        {
          obat_id: item.id,
          stock_system: item.stock,
          note: note,
          batch: batchChange,
          need_delete: needDeleteBatch,
        },
      ];
    });
    setNeedDeleteBatch([]);
    closeModal();
  };

  const getDiff = (drug) => {
    const found = itemAdjust.find((itm) => itm.obat_id === drug.id);
    const total = found
      ? found.batch?.reduce((sum, b) => sum + Number(b.stock || 0), 0)
      : drug.batch?.reduce((sum, b) => sum + Number(b.stock || 0), 0);

    return total - drug.stock;
  };

  const getStatus = (drug) => {
    const adjustedItem = itemAdjust.find((itm) => itm.obat_id === drug.id);
    if (!adjustedItem) return "Unchanged";

    const totalBatchStock = adjustedItem.batch?.reduce(
      (sum, b) => sum + Number(b.stock || 0),
      0,
    );
    return totalBatchStock === drug.stock ? "Unchanged" : "Adjusted";
  };

  return (
    <div className="min-h-screen flex flex-col space-y-6 w-full min-w-0">
      <PageCreateHeader
        icon={FiClipboard}
        title="Proses Stock Opname"
        description="Sesuaikan batch dan stok gudang dengan sistem"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Inventory", to: "/inventory" },
          { label: "Stock Opname", to: "/inventory/stock-opname" },
          { label: "Proses Stock Opname" },
        ]}
      />

    <main className="flex-1 min-h-0 flex flex-col gap-4 overflow-visible">
      {/* Content */}
      <div className="flex-1 min-h-0 flex flex-col overflow-hidden p-6 bg-white rounded-2xl font-sans shadow-md border border-gray-100 w-full min-w-0">
        {/* Button */}
        <div className="flex flex-wrap gap-4">
          <button
            className="flex items-center gap-2 bg-blue-400 hover:bg-blue-500 text-white px-2 py-2 rounded-lg shadow-md font-semibold transition"
            onClick={repairNotif}
          >
            <FiPrinter />
            Cetak Kartu Stock Opname
          </button>
          <button
            disabled={switchButton}
            className={`flex items-center gap-2 ${
              itemAdjust.length === 0
                ? "bg-gray-300 cursor-not-allowed hover:bg-gray-300"
                : "bg-green-500 hover:bg-green-600"
            }  text-white px-2 py-2 rounded-lg shadow-md font-semibold transition`}
            onClick={openDescModal}
          >
            <FiClipboard />
            Rebalance
          </button>
        </div>

        {/* Pagination */}
        <div className="flex justify-between items-center gap-4 flex-wrap">
          <div className="relative w-full">
            <FiSearch className="absolute top-3 left-4 text-gray-400" />
            <input
              type="text"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="Cari nama obat..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {role === "owner" && (
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Pilih Outlet:
              </label>
              <select
                className="border border-gray-300 rounded-lg px-4 py-2 shadow-sm text-sm"
                value={selectedOutlet}
                onChange={(e) => {
                  setSelectedOutlet(e.target.value);
                  localStorage.setItem("id_outlet", e.target.value);
                }}
              >
                <option value="">-- Pilih Outlet --</option>
                {outlets.map((outlet) => (
                  <option key={outlet.id} value={outlet.id}>
                    {outlet.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="w-full md:w-auto">
            <label className="mr-2 text-sm font-medium text-gray-600">
              Tampilkan
            </label>
            <select
              className="border border-gray-300 rounded-lg px-4 py-2 text-sm shadow-sm"
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(parseInt(e.target.value));
                setCurrentPage(1); // reset ke halaman pertama
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="flex-1 min-h-0 border-separate rounded-xl border border-solid overflow-y-auto">
          {loading ? (
            <div className="p-6 text-gray-600">Loading data...</div>
          ) : (
            <>
              <table className="w-full text-sm">
                <thead className="sticky top-0 z-10 bg-green-100 text-gray-600 font-semibold">
                  <tr>
                    <th scope="col" className="p-3 text-center w-10">
                      No
                    </th>
                    <th scope="col" className="p-3 text-left min-w-0">
                      Name
                    </th>
                    <th scope="col" className="p-3 text-center w-30">
                      Stock System
                    </th>
                    <th scope="col" className="p-3 text-left w-1/4">
                      Last Update
                    </th>
                    <th scope="col" className="p-3 text-center">
                      Adjust
                    </th>
                    <th scope="col" className="p-3 text-center">
                      Status
                    </th>
                    <th className="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.map((drug, index) => {
                    const item = stockData.find((d) => d.id === drug.id);
                    return (
                      <tr key={drug.id} className="hover:bg-gray-50 transition">
                        <td className="p-3 text-center">
                          {index + 1 + (currentPage - 1) * itemsPerPage}
                        </td>
                        <td className="p-3 whitespace-normal break-words w-72">{`${drug.name} ${drug.dosis}`}</td>
                        <td className="p-3 text-center">{drug.stock}</td>
                        <td className="p-3">{item?.last_updated}</td>
                        <td className="p-3 text-center">{getDiff(drug)}</td>
                        <td
                          className={`p-1 font-bold text-center ${
                            getStatus(drug) === "Adjusted"
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          {getStatus(drug)}
                        </td>
                        <td className="flex text-center justify-center gap-2 py-2">
                          <button
                            onClick={() => openModalAturStock(drug)}
                            className="flex justify-between items-center text-green-500 hover:text-green-700 p-1 rounded-lg border border-green-500 hover:border-green-700 transition"
                          >
                            <FiEdit />
                            &nbsp;Adjust Batch
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>

        {/* Pagination */}
        <div className="shrink-0 p-4 flex justify-between items-center text-sm">
          <span className="text-gray-600">
            Halaman {currentPage} dari {totalPages}
          </span>
          <div className="flex gap-2">
            <button
              className="flex items-center gap-1 px-3 py-1 bg-gray-200 rounded-full hover:bg-gray-300 transition disabled:opacity-50"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              <FiArrowLeft />
              Previous
            </button>
            <button
              className="flex items-center gap-1 px-3 py-1 bg-gray-200 rounded-full hover:bg-gray-300 transition disabled:opacity-50"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Next
              <FiArrowRight />
            </button>
          </div>
        </div>
      </div>

      {/* Modal Deskripsi */}
      {showDescriptionModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20">
          <div className="bg-white p-6 rounded-xl shadow-xl w-[400px]">
            <h4 className="text-xl font-semibold mb-3 text-gray-700">
              Deskripsi Stock Opname
            </h4>
            <textarea
              rows={4}
              value={descriptionInput}
              onChange={(e) => setDescriptionInput(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="Tulis deskripsi umum..."
            />
            <div className="mt-4 flex justify-end gap-2">
              <button
                onClick={() => setShowDescriptionModal(false)}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg transition"
              >
                <FiX className="inline mr-1" />
                Batal
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg transition"
              >
                {loadingSubmit ? (
                  <div className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    Processing...
                  </div>
                ) : (
                  <>
                    <FiCheck className="inline mr-1" />
                    Submit
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-lg font-semibold mb-2 text-green-600">
              Berhasil!
            </h2>
            <p>Stock Opname berhasil diproses. Mengarahkan...</p>
          </div>
        </div>
      )}

      {/* Modal Note */}
      {showNotePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10">
          <div className="bg-white p-6 rounded-xl shadow-xl w-96">
            <h4 className="text-lg font-semibold mb-3 text-gray-700">
              Catatan untuk:{" "}
              <span className="font-bold">
                {filteredData[currentNoteIndex]?.nama}
              </span>
            </h4>
            <textarea
              rows={4}
              value={noteInput}
              onChange={(e) => setNoteInput(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Tulis catatan di sini..."
            />
            <div className="mt-4 flex justify-end gap-2">
              <button
                onClick={() => setShowNotePopup(false)}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-full transition"
              >
                <FiX />
              </button>
              <button
                onClick={saveNote}
                className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-full transition"
              >
                <FiCheck />
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        id="modal-so-obat-stock"
        className="fixed inset-0 z-50 items-center hidden flex justify-center bg-black bg-opacity-40"
      >
        <div className="grid bg-white rounded-xl shadow-lg p-6 w-full max-w-4xl mx-4 gap-2">
          <h2 className="text-lg font-semibold mb-2">
            Atur Batch di{" "}
            <b>
              {itemObatSelected.name} {itemObatSelected.dosis}
            </b>
          </h2>

          <div className="relative overflow-y-auto shadow-md sm:rounded-md gap-6 mb-6 w-full">
            <table className="min-w-max w-full text-sm">
              <thead className="bg-green-100 text-gray-600 font-semibold">
                <tr>
                  <th scope="col" className="p-3 w-10">
                    No
                  </th>
                  <th className="text-left p-3">Expired</th>
                  <th className="text-left p-3">Stock</th>
                </tr>
              </thead>
              <tbody>
                {/* filter batchObatSeleted dengan itemAdjust yang sesuai dan tidak menampilkan batch ketika id batch ada di itemAdjust.need_delete */}
                {batchObatSelected
                  ?.filter(
                    (batch) =>
                      !itemAdjust
                        .find((i) => i.obat_id === itemObatSelected.id)
                        ?.need_delete?.includes(batch.id),
                  )
                  .map((batch, index) => {
                    return (
                      <tr>
                        <td className="text-center p-2">{index + 1}</td>
                        <td className="text-left p-2">
                          <input
                            type="date"
                            value={batch.expired_at?.split("T")[0] ?? ""}
                            onChange={(e) =>
                              handleBatchChange(
                                index,
                                "expired_at",
                                e.target.value,
                              )
                            }
                            className="w-full min-w-0 border-2 rounded-md px-2 py-1 text-sm text-gray-500"
                          />
                        </td>
                        <td className="flex text-left p-2 gap-2 items-center">
                          <input
                            type="text"
                            value={batch.stock}
                            onChange={(e) =>
                              handleBatchChange(
                                index,
                                "stock",
                                e.target.value || "0",
                              )
                            }
                            className="flex-1 min-w-0 w-full border-2 rounded-md px-2 py-1 text-sm text-gray-500"
                          />
                          <button
                            onClick={() => handleAddToNeedDelete(batch)}
                            className="text-red-500 px-2 hover:text-red-700 rounded-lg border border-red-500 hover:border-red-700 transition"
                          >
                            <FiX />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <h3 className="text-md font-bold mb-1">
            Beri catatan untuk SO Obat ini
          </h3>
          <textarea
            className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            placeholder="Tulis catatan di sini..."
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
              setNotes((prev) => ({
                ...prev,
                [itemObatSelected.id]: e.target.value,
              }));
            }}
          />
          <div className="flex justify-end space-x-2">
            <button
              className="px-3 py-1 text-sm rounded bg-gray-200 hover:bg-gray-300"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              onClick={() =>
                handleAdjustItem(
                  itemObatSelected,
                  note,
                  batchObatSelected?.filter(
                    (batch) =>
                      !itemAdjust
                        .find((i) => i.obat_id === itemObatSelected.id)
                        ?.need_delete?.includes(batch.id),
                  ),
                )
              }
              className="px-3 py-1 text-sm rounded bg-green-200 hover:bg-gray-300"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </main>
    </div>
  );
};

export default CreateStockOpname;
